<template>
    <div class="pa-4 fill-height d-flex flex-column flex-grow-1">
        <AgGrid class="flex-grow-1" ref="logAppointmentAgGridRef" :fetchUrl="logAppointmentFetchUrl" 
        :columnDefs="logAppointmentColDefs" :gridParams="logAppointmentGridParams" :ssrm="true" :ssrmBlockSize="50"/>
    </div>
</template>

<script setup>
    
    //Grid data binded through SSRM
    //const serverSideDatasource in AgGrid.vue

    import { inject, ref, useTemplateRef } from 'vue';
    import AgGrid from '@/components/AgGrid.vue';
    import { useUserStore } from '@/stores/userStore';

    const props = defineProps({
        customerReference: {
            type: String,
            default: null,
        },
    });
    const emit = defineEmits(['pending-changes']);
    
    const urlWebAPI = inject('urlWebAPI');
    const translate = inject('translate');
    const userStore = useUserStore();
    const logAppointmentGridRef = useTemplateRef('logAppointmentAgGridRef');

    const logAppointmentFetchUrl = 'GetLogAppointment';
    const logAppointmentColDefs = [
        {
            field: 'id',
            headerName: 'id',
            
            hide: true
        },
        {
            field: 'userId',
            headerName: 'user Id',
            
            hide: true,
        },
        {
            field: 'userReference',
            headerName: translate('userName', 'column'),
        },
        {
            field:'userFirstName',
            headerName: translate('firstName', 'column'),
            
        },
        {
            field:'userLastName',
            headerName: translate('lastName', 'column'),
            
        },

        {
            field: 'logDate',
            headerName: 'Log Date',
            
            type: 'date'
        },
        {
            field: 'appointmentUid',
            headerName: 'appointmentUid',
            
            hide: true
        },
        {
            field: 'message',
            headerName: translate('shortMsg', 'column'),
            
        },
        {
            field: 'data',
            headerName: 'Data',
            type: 'appointmentAction',
            
        }
    ];

    const logAppointmentGridParams = {
        token: userStore.getUser().token,
        customerReference: props.customerReference
    };



</script>